import FieldStrategy from '../FieldStrategy';
import { generateFieldName } from '@/views/fusion/investment/intelligence-create/tools';
import { clone, hasOwnProperty } from '@/utils';
import { isNotNullAndUnDef } from '@/utils/is';
import { checkboxFilterNone, transformSelectedTimeToTimeSeries } from '@/tools/form';
import { generateHtmlContent } from '@/views/fusion/investment/intelligence-create/tools/form';
import {
  CAMPAIGN_MODULE_KEY,
  CAMPAIGN_DELIVERY_FORM_KEY,
  CAMPAIGN_BUDGET_AND_BID_FORM_KEY,
  CREATIVE_MODULE_KEY,
  CREATIVE_CONTENT_FORM_KEY,
  CREATIVE_COMPONENTS_FORM_KEY,
  TARGETING_MODULE_KEY,
  MATERIAL_MODULE_KEY,
  TITLE_MODULE_KEY,
  SITE_MODULE_KEY,
} from '@/views/fusion/investment/intelligence-create/strategy/constants';
import { OPTIONS_TYPE, CHANNEL_INTERFACE_TYPE, TIME_PERIOD_LENGTH } from '@/enums';
import calculator from '@/utils/calculator';

function getNumberOptions(min, max, disabled_num = 999) {
  const options = [];
  for (let i = min; i <= max; i++) {
    options.push({ label: i, value: i, disabled: i >= disabled_num });
  }
  return options;
}

// 品牌形象
const brand = {
  value: {},
  children: {
    brand_url: {
      label: '品牌形象',
      type: 'image',
      isPreview: false,
      limit: 1,
      is_open: false,
      element_type: 'image',
      temp_material: null,
      material_restriction: [{ width: 120, height: 120 }],
      value: '',
      rules: { required: true, message: '请选择品牌头像', trigger: ['change'] },
    },
    brand_name: {
      label: ' ',
      type: 'input',
      props: {
        placeholder: '请输入品牌名称',
        showWordLimit: true,
        maxlength: 11,
      },
      value: '',
      rules: { required: true, message: '请输入品牌名称', trigger: ['change'] },
    },
  },
};

// 落地页跳转类型
const fusion__site_type = {
  label: '落地页跳转类型',
  type: 'radio-group',
  isButton: true,
  options: [
    { label: '应用内页面', value: OPTIONS_TYPE.UNLIMITED },
    { label: '微信小游戏', value: OPTIONS_TYPE.CUSTOM },
  ],
  value: OPTIONS_TYPE.UNLIMITED,
};

// 副标题
const subtitle = {
  label: '副标题',
  type: 'input',
  props: {
    placeholder: '请输入创意副标题',
    showWordLimit: true,
    maxlength: 24,
  },
  value: '',
  rules: { required: true, message: '请输入创意副标题', trigger: ['change'] },
};

// 创意磁贴
const plugin_ids = {
  label: '创意磁贴',
  formItemTips: {
    props: {
      class: 'color-red',
    },
    content: '创意磁贴组件仅视频类素材样式可用，使用前请检查是否符合使用要求',
  },
  is_open: false,
  isPreview: false,
  // 临时分配
  assignSelection: {},
  // 格式 - { [advertiser_id]: [{}, {}] }
  value: {},
};

// 附加创意信息
const additional_creative_information = {
  label: '附加创意信息',
  type: 'checkbox-group',
  isButton: true,
  options: [],
  value: [],
};

// 创意工具
const prog_flag = {
  label: '创意工具',
  type: 'checkbox-group',
  isButton: true,
  options: [
    { label: '图片生成视频', value: '32' },
  ],
  value: [],
};

// 前卡模块文案
const video_text = {
  value: {},
  children: {
    first_text: {
      label: '前卡模块文案',
      type: 'input',
      props: {
        placeholder: '请输入前卡模块文案一',
        showWordLimit: true,
        maxlength: 8,
      },
      value: '',
      rules: { required: true, message: '请输入前卡模块文案一', trigger: ['change'] },
    },
    second_text: {
      label: ' ',
      type: 'input',
      props: {
        placeholder: '请输入前卡模块文案二',
        showWordLimit: true,
        maxlength: 22,
      },
      value: '',
      rules: { required: true, message: '请输入前卡模块文案二', trigger: ['change'] },
    },
  },
};

// 微信小游戏组件
const idea_plugin_group = {
  value: {},
  children: {
    wechat_miniprogram_name: {
      label: '微信小游戏组件',
      type: 'input',
      hidden: false,
      props: {
        placeholder: '请输入微信小游戏名称',
      },
      value: '',
      rules: { required: true, message: '请输入微信小游戏名称', trigger: ['change'] },
    },
    wechat_miniprogram_id: {
      label: ' ',
      type: 'input',
      hidden: false,
      props: {
        placeholder: '请输入微信小游戏原始ID',
      },
      value: '',
      rules: { required: true, message: '请输入微信小游戏原始ID', trigger: ['change'] },
    },
  },
};

// 使用单元出价
const bid_source = {
  label: '使用单元出价',
  type: 'radio-group',
  isButton: true,
  props: {
    disabled: false,
  },
  options: [
    { label: '启用', value: 1 },
    { label: '不启用', value: 2 },
  ],
  value: 2,
};

// 广告出价
const price = {
  label: '广告出价',
  type: 'input-number',
  hidden: true,
  props: {
    step: 1,
    precision: 2,
    min: 0.01,
    max: 999999999.00,
  },
  formItemTips: {
    props: {
      class: 'inline-block',
      style: {
        marginLeft: '10px',
      },
    },
    content: '元',
  },
  value: undefined,
  rules: { required: true, message: '请输入广告出价', trigger: ['change'] },
};

// 优化目标出价
const ocpc_bid = {
  label: '优化目标出价',
  type: 'input-number',
  hidden: true,
  props: {
    step: 1,
    precision: 2,
    min: 0.01,
    max: 999999999.00,
  },
  formItemTips: {
    props: {
      class: 'inline-block',
      style: {
        marginLeft: '10px',
      },
    },
    content: '元',
  },
  value: undefined,
  rules: { required: true, message: '请输入优化目标出价', trigger: ['change'] },
};

// 深度优化目标出价
const deep_ocpc_bid = {
  label: '深度优化出价',
  type: 'input-number',
  hidden: true,
  props: {
    step: 1,
    precision: 2,
    min: 0.01,
    max: 999999999.00,
  },
  formItemTips: {
    props: {
      class: 'inline-block',
      style: {
        marginLeft: '10px',
      },
    },
    content: '元',
  },
  value: undefined,
  rules: { required: true, message: '请输入深度优化出价', trigger: ['change'] },
};

// 深度ROI系数出价
const roi_ratio = {
  label: '深度ROI系数出价',
  type: 'input-number',
  hidden: true,
  props: {
    step: 1,
    precision: 3,
    min: 0.001,
    max: 1000,
  },
  value: undefined,
  rules: { required: true, message: '请输入优化ROI系数出价', trigger: ['change'] },
};

// 【内容配置】表单配置
const content_form_config = {
  brand,
  fusion__site_type,
};

// 【创意组件】表单配置
const creative_components_config = {
  subtitle,
  plugin_ids,
  additional_creative_information,
  prog_flag,
  video_text,
  idea_plugin_group,
};

const creative_price_config = {
  bid_source,
  price,
  ocpc_bid,
  deep_ocpc_bid,
  roi_ratio,
};

/**
 * 百度策略类
 */
export default class BaiduFieldStrategy extends FieldStrategy {
  /**
   * 获取差异化模块字段
   * @returns {Object}
   */
  getDifferentiatedFields() {
    return {
      campaign_config: {
        config: {
          delivery_form: {
            config: {
              // 投放平台
              delivery_platform_type: {
                value: '3',
                backup_value: '3',
              },
              // 投放内容
              delivery_content_id: {
                type: '',
                hidden: true,
                is_single_advertiser_assign: true,
                is_open: false,
                value: {
                  type_selection: [
                    { label: 'iOS应用', value: '2' },
                  ],
                  result_map: {},
                },
                backup_value: {
                  type_selection: [
                    { label: 'iOS应用', value: '2' },
                  ],
                  result_map: {},
                },
                isPreview: false,
                rules: {
                  required: true,
                  trigger: ['change'],
                  validator: (_, value, callback) => {
                    if (Object.keys(value.result_map).length) {
                      callback();
                    } else {
                      callback(new Error('请选择投放内容'));
                    }
                  },
                },
              },
              // 应用渠道包
              channel_package_id: {
                label: '应用渠道包',
                type: 'radio-group',
                isButton: true,
                hidden: false,
                options: [{ label: '自动配置', value: 'AUTO' }],
                value: 'AUTO',
                labelTips: generateHtmlContent({
                  content: [
                    '系统将自动根据已添加的渠道号关联媒体平台的渠道包(渠道标识)',
                    '若渠道包不存在，可前往媒体平台先行创建或预览时手动选择渠道包',
                  ],
                }),
              },
              // 下载方式
              download_type: {
                label: '下载方式',
                type: 'radio-group',
                isButton: true,
                hidden: false,
                options: [{ label: '直接下载', value: '0' }],
                value: '0',
              },
              // 优先应用商店下载
              open_url: {
                label: '优先应用商店下载',
                type: 'radio-group',
                isButton: true,
                hidden: false,
                options: [
                  { label: '启用', value: '1' },
                  { label: '不启用', value: '0' },
                ],
                value: '0',
              },
            },
          },
          site_form: {
            config: {
              site_sets: {
                props: {
                  disabled: false,
                },
                value: ['1'],
                rules: { required: true, message: '请选择广告版位', trigger: ['change'] },
              },
            },
          },
          schedule_form: {
            config: {
              time_period: {
                isHour: true,
                value: { schedule_time_content: new Array(TIME_PERIOD_LENGTH.HOUR).fill(1).join('') },
              },
            },
          },
          budget_and_bid_form: {
            config: {
              // 广告出价
              price: {
                hidden: true,
              },
              // 出价方式
              price_type: {
                value: '3',
              },
              // 出价策略
              price_strategy: {
                hidden: false,
                value: '1',
              },
              // 转化事件
              convert_id: {
                hidden: false,
              },
              // 优化目标
              fusion__optimize_goal: {
                label: '优化目标',
                type: 'select',
                hidden: false,
                props: {
                  clearable: false,
                },
                options: [],
                value: '',
                backup_value: '',
                rules: { required: true, message: '请选择优化目标', trigger: ['change'] },
              },
              // 付费优化类型
              trans_type_attribute: {
                label: '付费优化类型',
                type: 'radio-group',
                isButton: true,
                hidden: true,
                props: {
                  disabled: false,
                },
                options: [
                  { label: '按付费人数优化', value: '1' },
                  { label: '按付费次数优化', value: '2' },
                ],
                value: '1',
              },
              // 使用ROI优化
              use_roi: {
                label: '使用ROI优化',
                type: 'radio-group',
                isButton: true,
                hidden: true,
                options: [
                  { label: '启用', value: '1' },
                  { label: '不启用', value: '0' },
                ],
                value: '0',
              },
              // 优化目标出价
              ocpc_bid: {
                label: '优化目标出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 2,
                  min: 0.01,
                  max: 999999999.00,
                },
                formItemTips: {
                  props: {
                    class: 'inline-block',
                    style: {
                      marginLeft: '10px',
                    },
                  },
                  content: '元',
                },
                value: undefined,
                rules: { required: true, message: '请输入优化目标出价', trigger: ['change'] },
              },
              // 深度优化目标出价
              deep_ocpc_bid: {
                label: '深度优化出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 2,
                  min: 0.01,
                  max: 999999999.00,
                },
                formItemTips: {
                  props: {
                    class: 'inline-block',
                    style: {
                      marginLeft: '10px',
                    },
                  },
                  content: '元',
                },
                value: undefined,
                rules: { required: true, message: '请输入深度优化出价', trigger: ['change'] },
              },
              // 深度ROI系数出价
              roi_ratio: {
                label: '深度ROI系数出价',
                type: 'input-number',
                hidden: true,
                props: {
                  step: 1,
                  precision: 3,
                  min: 0.001,
                  max: 1000,
                },
                value: undefined,
                rules: { required: true, message: '请输入优化ROI系数出价', trigger: ['change'] },
              },
            },
          },
        },
      },
      creative_config: {
        config: {
          content_form: {
            config: {
              delivery_mode: {
                label: '投放模式',
                type: 'radio-group',
                isButton: true,
                disabled: false,
                options: [
                  { label: '组件化创意', value: '1' },
                  { label: '自定义创意', value: '0' },
                ],
                value: '1',
                backup_value: '1',
                labelTips: generateHtmlContent({
                  content: [
                    '百度媒体组件化创意形式支持以下素材规格',
                    '1. 图片类：375*245、1140*640、600*300、750*100、960*640',
                    '2. 视频类：1280*720、720*1280',
                  ],
                  is_index: false,
                }),
              },
              creative_template_id: {
                label: '创意形式',
                type: 'radio-group',
                isBox: true,
                hidden: true,
                options: [],
                value: null,
                backup_value: null,
              },
              videos_num_per_creative: {
                label: '每创意分配视频数',
                type: 'select',
                hidden: false,
                options: getNumberOptions(0, 12),
                value: 6,
              },
              images_num_per_creative: {
                label: '每创意分配图片数',
                type: 'select',
                hidden: false,
                options: getNumberOptions(0, 12, 7),
                value: 0,
              },
              titles_num_per_creative: {
                label: '每创意分配标题数',
                type: 'select',
                hidden: false,
                options: getNumberOptions(1, 6),
                value: 6,
              },
              sites_num_per_creative: {
                label: '每创意分配落地页数',
                type: 'select',
                hidden: false,
                options: getNumberOptions(1, 1),
                value: 1,
              },
            },
          },
          creative_price: {
            title: '创意出价',
            config: {},
          },
        },
      },
      targeting_config: {
        config: {
          targeting_form: {
            config: {
              // 年龄
              age: {
                value: {},
                children: {
                  age_selection: {
                    label: '年龄',
                    type: 'radio-group',
                    isButton: true,
                    options: [
                      { label: '不限', value: OPTIONS_TYPE.UNLIMITED },
                      { label: '指定年龄段', value: OPTIONS_TYPE.CUSTOM },
                    ],
                    value: OPTIONS_TYPE.UNLIMITED,
                  },
                  age: {
                    label: ' ',
                    type: 'checkbox-group',
                    hidden: true,
                    isBox: true,
                    options: [],
                    value: [],
                    rules: { required: true, message: '请选择年龄', trigger: ['change'] },
                  },
                },
              },
              // 人生阶段
              life_stage: {
                label: '人生阶段',
                type: 'checkbox-group',
                isButton: true,
                options: [],
                value: [OPTIONS_TYPE.UNLIMITED],
              },
              // 学历
              education: {
                label: '学历',
                type: 'checkbox-group',
                isButton: true,
                options: [],
                value: [OPTIONS_TYPE.UNLIMITED],
              },
              // 网络
              net: {
                label: '网络',
                type: 'radio-group',
                isButton: true,
                options: [],
                value: OPTIONS_TYPE.UNLIMITED,
              },
            },
          },
        },
      },
      material_config: {
        config: {
          material_form: {
            config: {
              material: {
                props: {
                  type: 'image',
                  tempMaterial: null,
                },
                materialRestriction: [],
                material_type: null,
                isSupportSwitchImgType: false,
                video: {
                  // 竖版视频
                  '720#1280': {
                    // 横板封面
                    horizontal_cover: {
                      width: 1140,
                      height: 640,
                      size: 500,
                    },
                  },
                },
              },
            },
          },
        },
      },
    };
  }

  /**
   * 添加事件
   * @param {Object} config 模块配置
   * @param {Object} controller 控制器
   */
  addEvent(config, controller) {
    this.config = config;
    super.addEvent(config);

    const {
      campaign_config: {
        config: {
          delivery_form,
          site_form,
          budget_and_bid_form,
        },
      },
    } = config;

    const {
      fusion__channel_code: {
        children: {
          fusion__channel_codes,
        },
      },
      delivery_platform_type,
      delivery_content_id,
      channel_package_id,
      download_type,
      open_url,
    } = delivery_form.config;

    const {
      site_set_type,
      site_sets,
    } = site_form.config;

    const {
      daily_budget_type,
      price,
      price_type,
      price_strategy,
      convert_id,
      fusion__optimize_goal,
      deep_convert_type,
      trans_type_attribute,
      use_roi,
      ocpc_bid,
      deep_ocpc_bid,
      roi_ratio,
    } = budget_and_bid_form.config;

    /**
     * 出价方式为【oCPX】
     * oCPC: '3'
     * @returns {boolean}
     */
    const isOcpx = () => price_type.value === '3';

    /**
     * 出价策略为【最大转化投放】
     * 最大转化投放: '2'
     * @returns {boolean}
     */
    const isMax = () => price_strategy.value === '2';

    /**
     * 设置付费优化类型可见性
     * 满足以下条件即可设置可见
     * 1. 出价方式为【oCPX】
     * 2. 优化目标为以下值之一
     * - 付费: 26
     * @returns {void}
     */
    const setTransTypeAttributeVisible = () => {
      const is_match = ['26'].includes(fusion__optimize_goal.value);
      trans_type_attribute.hidden = !(isOcpx() && is_match);
    };

    /**
     * 设置使用ROI优化可见性
     * 满足以下条件即可设置可见
     * 1. 出价方式为【oCPX】
     * 2. 优化目标为以下值之一
     * - 付费: 26
     * @returns {void}
     */
    const setUseRoiVisible = () => {
      const is_match = ['26'].includes(fusion__optimize_goal.value);
      use_roi.hidden = !(isOcpx() && is_match);
    };

    /**
     * 设置优化目标出价可见性
     * 满足以下条件即可设置可见
     * 1. 出价方式为【oCPX】
     * 2. 出价策略不为【最大转化投放】
     * 3. 优化目标有值
     * @returns {void}
     */
    const setOcpcBidVisible = () => {
      ocpc_bid.hidden = !(isOcpx() && !isMax() && !!fusion__optimize_goal.value);
    };

    /**
     * 设置深度优化出价可见性
     * 满足以下条件即可设置可见
     * 1. 出价方式为【oCPX】
     * 2. 出价策略不为【最大转化投放】
     * 3. 深度优化目标存在
     * 4. 深度优化目标的值为以下值之一
     * - 注册: 25
     * - 付费：26
     * @returns {void}
     */
    const setDeepConvertPriceVisible = () => {
      const is_visible = !deep_convert_type.hidden;
      const is_match = ['25', '26'].some(value => deep_convert_type.value === value);
      deep_ocpc_bid.hidden = !(isOcpx() && !isMax() && is_visible && is_match);
    };

    /**
     * 设置深度ROI系数出价可见性
     * 满足以下条件即可设置可见
     * 1. 出价方式为【oCPX】
     * 2. 出价策略不为【最大转化投放】
     * 3. 使用ROI优化存在
     * 4. 使用ROI优化的值为【启用['1']】
     * @returns {void}
     */
    const setRoiRatioVisible = () => {
      const is_visible = !use_roi.hidden;
      const is_match = use_roi.value === '1';
      roi_ratio.hidden = !(isOcpx() && !isMax() && is_visible && is_match);
    };

    /**
     * 设置深度优化目标选项
     * @return {Promise<void>}
     */
    const setDeepConvertGoalOptions = async() => {
      const { id } = convert_id.value ? JSON.parse(convert_id.value) : {};
      if (fusion__optimize_goal.value) {
        const deep_convert_type_options = await controller.getDeepConvertGoalList({ baidu_params: { filtering: { convert_id: id, convert_goal: fusion__optimize_goal.value }}});
        deep_convert_type.options = deep_convert_type_options.filter(({ value }) => value !== fusion__optimize_goal.value);
        const is_match_deep_convert_type = deep_convert_type.options.some(({ value }) => deep_convert_type.value === value);
        !is_match_deep_convert_type && (deep_convert_type.value = '');
      }
    };

    /**
     * 清空已选择的转化事件、优化目标、深度优化目标
     * @returns {void}
     */
    const clearConvertField = () => {
      convert_id.value = '';
      fusion__optimize_goal.value = '';
      fusion__optimize_goal.backup_value = '';
      fusion__optimize_goal.options = [];
      deep_convert_type.value = '';
      deep_convert_type.options = [];
      (fusion__channel_codes.value?.length ? fusion__channel_codes.value : []).forEach(({ list = [] }) => {
        list.forEach(item => {
          delete item.conversion;
        });
      });
      price_type.on.change();
    };

    // 投放平台
    delivery_platform_type.on = {
      change: () => {
        const is_android = delivery_platform_type.value === '3';
        const is_ios = delivery_platform_type.value === '2';

        delivery_content_id.hidden = !is_ios;
        channel_package_id.hidden = !is_android;
        download_type.hidden = !is_android;
        open_url.hidden = !is_android;

        const is_change = delivery_platform_type.value !== delivery_platform_type.backup_value;
        if (is_change) {
          delivery_platform_type.backup_value = delivery_platform_type.value;

          delivery_content_id.value.result_map = {};
          delivery_content_id.backup_value = JSON.parse(JSON.stringify(delivery_content_id.value));
          clearConvertField();
        }
      },
    };

    // 投放内容
    delivery_content_id.on = {
      change: () => {
        const is_change = JSON.stringify(delivery_content_id.value) !== JSON.stringify(delivery_content_id.backup_value);
        if (is_change) {
          delivery_content_id.backup_value = JSON.parse(JSON.stringify(delivery_content_id.value));

          clearConvertField();
        }
      },
    };

    // 版位类型
    const superSiteSetTypeChange = site_set_type.on.change;
    site_set_type.on = {
      change: () => {
        superSiteSetTypeChange();
        site_sets.on.change();
      },
    };

    // 广告版位
    site_sets.on = {
      change: () => {
        // 版位类型为【指定版位[2]】
        const is_custom = site_set_type.value === 2;
        // 广告版位包含【百青藤['4']】
        const is_include_4 = site_sets.value.includes('4');
        // 出价方式为【CPM['2']】
        const is_cpm = price_type.value === '2';
        /**
         * 版位类型为【指定版位[2]】且广告版位包含【百青藤['4']】时
         * - 广告版位 - 仅允许选中【百青藤['4']】
         * - 出价方式 - 【CPM['2']】选项禁选
         */
        // 广告版位
        site_sets.options.forEach(opt => {
          if (opt.value !== '4') {
            Object.assign(opt, { disabled: is_custom && is_include_4 });
          }
        });
        if (is_custom && is_include_4) {
          site_sets.value = ['4'];
        }
        // 出价方式
        price_type.options.forEach(opt => {
          if (opt.value === '2') {
            Object.assign(opt, { disabled: is_custom && is_include_4 });
          }
        });
        if (is_custom && is_include_4 && is_cpm) {
          price_type.value = '1';
          price_type.on.change();
        }
      },
    };

    // 出价方式
    price_type.on = {
      change: () => {
        price.hidden = isOcpx();
        price_strategy.hidden = !isOcpx();
        convert_id.hidden = !isOcpx();
        fusion__optimize_goal.hidden = !isOcpx();
        fusion__optimize_goal.on.change();
        price_strategy.on.change();
      },
    };

    // 出价策略
    price_strategy.on = {
      change: () => {
        /**
         * 出价方式为oCPX且出价策略为【最大转化投放['2']】时
         * - 日预算禁选
         * - 日预算为指定预算
         */
        daily_budget_type.props.disabled = isOcpx() && isMax();
        if (isOcpx() && isMax()) {
          daily_budget_type.value = 'BUDGET_MODE_DAY';
          daily_budget_type.on.change();
        }

        setOcpcBidVisible();
        setDeepConvertPriceVisible();
        setRoiRatioVisible();
      },
    };

    // 优化目标
    fusion__optimize_goal.on = {
      change: async() => {
        setTransTypeAttributeVisible();
        setUseRoiVisible();
        use_roi.on.change();
        setOcpcBidVisible();

        const is_change = JSON.stringify(fusion__optimize_goal.value) !== JSON.stringify(fusion__optimize_goal.backup_value);
        if (is_change) {
          fusion__optimize_goal.backup_value = fusion__optimize_goal.value;
          await setDeepConvertGoalOptions();
        }

        deep_convert_type.hidden = !(isOcpx() && deep_convert_type.options.length);
        deep_convert_type.on.change();
      },
    };

    // 深度优化目标
    deep_convert_type.on = {
      change: () => {
        setDeepConvertPriceVisible();
      },
    };

    // 使用ROI优化
    use_roi.on = {
      change: () => {
        const is_on = use_roi.value === '1';
        const is_visible = !use_roi.hidden;
        trans_type_attribute.props.disabled = is_visible && is_on;
        (is_visible && is_on) && (trans_type_attribute.value = '1');

        setRoiRatioVisible();
      },
    };

    const {
      creative_config: {
        config: {
          content_form,
          creative_components,
          creative_price,
        },
      },
    } = config;

    const {
      delivery_mode,
      creative_template_id,
      videos_num_per_creative,
      images_num_per_creative,
      titles_num_per_creative,
      sites_num_per_creative,
      fusion__site_type,
    } = content_form.config;

    const {
      idea_plugin_group,
    } = creative_components.config;

    const {
      bid_source,
      price: creative_price_price,
      ocpc_bid: creative_price_ocpc_bid,
      deep_ocpc_bid: creative_price_deep_ocpc_bid,
      roi_ratio: creative_price_roi_ratio,
    } = creative_price.config;

    /**
     * 重新渲染动态创意组件
     * @param {Object} config 模块配置
     * @param {Object} controller 控制器
     * @returns {void}
     */
    const reRenderDynamicComponent = (config, controller) => {
      const {
        campaign_config: {
          config: {
            delivery_form: {
              config: {
                delivery_platform_type,
              },
            },
            site_form: {
              config: {
                site_set_type,
                site_sets,
              },
            },
          },
        },
        creative_config: {
          config: {
            content_form: {
              config: {
                delivery_mode,
                creative_template_id,
              },
            },
          },
        },
      } = config;

      const is_custom = delivery_mode.value === '0';
      const params = {
        ...(site_set_type.value === 2 && { filtering: { site_sets: site_sets.value }}),
        baidu_params: {
          filtering: {
            delivery_platform_type: delivery_platform_type.value,
            delivery_mode: delivery_mode.value,
            ...(is_custom && { creative_template_id: creative_template_id.value }),
          },
        },
      };

      this.renderDynamicComponent({ config, params, controller });
    };

    // 投放模式
    delivery_mode.on = {
      change: () => {
        const is_custom = delivery_mode.value === '0';

        creative_template_id.hidden = !is_custom;
        [
          videos_num_per_creative,
          images_num_per_creative,
          titles_num_per_creative,
          sites_num_per_creative,
        ].forEach(config => {
          config.hidden = is_custom;
        });

        const is_change = delivery_mode.value !== delivery_mode.backup_value;
        if (is_change) {
          delivery_mode.backup_value = delivery_mode.value;

          if (bid_source) {
            (is_custom || isMax()) && (bid_source.value = 2);
            bid_source.props.disabled = (is_custom || isMax());
            bid_source.on.change();
          }

          reRenderDynamicComponent(config, controller);
        }
      },
    };

    // 创意形式
    creative_template_id.on = {
      change: () => {
        const is_change = creative_template_id.value !== creative_template_id.backup_value;
        if (is_change) {
          creative_template_id.backup_value = creative_template_id.value;
          reRenderDynamicComponent(config, controller);
        }
      },
    };

    // 每创意分配视频数
    videos_num_per_creative.on = {
      change: () => {
        const value = videos_num_per_creative.value;
        images_num_per_creative.options.forEach(opt => {
          opt.disabled = (opt.value + value) > 12;
        });
      },
    };

    // 每创意分配图片数
    images_num_per_creative.on = {
      change: () => {
        const value = images_num_per_creative.value;
        videos_num_per_creative.options.forEach(opt => {
          opt.disabled = (opt.value + value) > 12;
        });
      },
    };

    // 落地页跳转类型
    if (fusion__site_type) {
      fusion__site_type.on = {
        change: () => {
          const is_custom = fusion__site_type.value === OPTIONS_TYPE.CUSTOM;
          if (idea_plugin_group) {
            const { wechat_miniprogram_name, wechat_miniprogram_id } = idea_plugin_group.children;
            wechat_miniprogram_name.hidden = !is_custom;
            wechat_miniprogram_id.hidden = !is_custom;
          }
        },
      };
    }

    // 使用单元出价
    if (bid_source) {
      bid_source.on = {
        change: () => {
          const is_on = bid_source.value === 1;
          creative_price_price.hidden = !(is_on && !price.hidden);
          creative_price_ocpc_bid.hidden = !(is_on && !ocpc_bid.hidden);
          creative_price_deep_ocpc_bid.hidden = !(is_on && !deep_ocpc_bid.hidden);
          creative_price_roi_ratio.hidden = !(is_on && !roi_ratio.hidden);
        },
      };
    }

    const {
      targeting_config: {
        config: {
          targeting_form,
        },
      },
    } = config;

    const {
      age: {
        children: {
          age_selection,
          age,
        },
      },
      life_stage,
      education,
    } = targeting_form.config;

    // 年龄
    age_selection.on = {
      change: () => {
        const is_custom = age_selection.value === OPTIONS_TYPE.CUSTOM;
        age.hidden = !is_custom;
      },
    };

    // 人生阶段
    life_stage.on = {
      change: () => {
        life_stage.value = checkboxFilterNone(life_stage.value, OPTIONS_TYPE.UNLIMITED);
      },
    };

    // 学历
    education.on = {
      change: () => {
        education.value = checkboxFilterNone(education.value, OPTIONS_TYPE.UNLIMITED);
      },
    };
  }

  /**
   * 获取覆盖字符对象
   * @returns {Object}
   */
  getDifferentiatedOverrides() {
    // 应用渠道包
    const channel_package_id = generateFieldName([CAMPAIGN_MODULE_KEY, CAMPAIGN_DELIVERY_FORM_KEY, 'channel_package_id']);

    // 转化事件
    const convert_id = generateFieldName([CAMPAIGN_MODULE_KEY, CAMPAIGN_BUDGET_AND_BID_FORM_KEY, 'convert_id']);

    // 投放模式
    const delivery_mode = generateFieldName([CREATIVE_MODULE_KEY, CREATIVE_CONTENT_FORM_KEY, 'delivery_mode']);

    // 品牌形象
    const brand_url = generateFieldName([CREATIVE_MODULE_KEY, CREATIVE_CONTENT_FORM_KEY, 'brand.brand_url']);

    // 创意磁贴
    const plugin_ids = generateFieldName([CREATIVE_MODULE_KEY, CREATIVE_COMPONENTS_FORM_KEY, 'plugin_ids']);

    return {
      [channel_package_id]: ({ field_config }) => {
        field_config.labelTips = '';
      },
      [convert_id]: ({ field_config }) => {
        field_config.type = 'label';
        field_config.value = field_config.value ? JSON.parse(field_config.value).name : '-';
        field_config.isPreview = true;
      },
      [delivery_mode]: ({ field_config }) => {
        field_config.labelTips = '';
      },
      [brand_url]: ({ field_config }) => {
        field_config.isPreview = true;
        field_config.type = '';
      },
      [plugin_ids]: ({ field_config }) => {
        field_config.isPreview = true;
        field_config.formItemTips.content = '';
      },
    };
  }

  /**
   * 设置配置模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setFieldDataSources(config, controller) {
    try {
      await super.setFieldDataSources(config, controller);
      const {
        campaign_config: {
          config: {
            site_form,
            budget_and_bid_form,
          },
        },
      } = config;
      const {
        site_sets,
      } = site_form.config;
      const {
        price_type,
      } = budget_and_bid_form.config;
      site_sets.options = site_sets.options.map((res) => ({ ...res, disabled: false }));
      price_type.options = price_type.options.map((res) => ({ ...res, disabled: false }));
    } catch (error) {
      console.error(error);
      throw new Error('BaiduFieldStrategy: setFieldDataSources fail');
    }
  }

  /**
   * 设置定向模块的数据源
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   */
  async setTargetingDataSources(config, controller) {
    await super.setTargetingDataSources(config, controller);
    const {
      age: {
        children: {
          age,
        },
      },
      life_stage,
      education,
      net,
    } = config.targeting_config.config.targeting_form.config;

    // 定向字典
    const targeting_dictionary = await controller.getTargetingDictionary(['age', 'life_stage', 'education', 'net']);
    const unlimited_selection = { label: '不限', value: OPTIONS_TYPE.UNLIMITED };

    // 年龄
    age.options = targeting_dictionary?.age || [];
    // 人生阶段
    life_stage.options = [unlimited_selection, ...(targeting_dictionary?.life_stage || [])];
    // 学历
    education.options = [unlimited_selection, ...(targeting_dictionary?.education || [])];
    // 网络
    net.options = [unlimited_selection, ...(targeting_dictionary?.net || [])];
  }

  /**
   * 模块字段排序
   * @param {Object} fields
   * @returns {Object}
   */
  async setFieldsSort(fields) {
    return Promise.resolve(fields);
  }

  /**
   * 设置动态渲染组件
   * @param {Object} config 模块表单配置
   * @param {Object} controller 控制器
   * @param {Object} payload 传递的数据，不限制键名和值
   */
  async setDynamicComponent(config, controller, payload) {
    if (config && controller && payload) {
      const { raw_ref_form_model, raw_form_model, form_assign_data } = payload;
      const is_site_set_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.site_form']?.site_set_type) !== JSON.stringify(raw_form_model['campaign_config.site_form']?.site_set_type);
      const is_site_sets_changed = JSON.stringify(raw_ref_form_model['campaign_config.site_form']?.site_sets) !== JSON.stringify(raw_form_model['campaign_config.site_form']?.site_sets);
      const is_delivery_platform_type_changed = JSON.stringify(raw_ref_form_model['campaign_config.delivery_form']?.delivery_platform_type) !== JSON.stringify(raw_form_model['campaign_config.delivery_form']?.delivery_platform_type);

      /**
       * 只要以下条件任意一个满足，则重新请求获取创意组件
       * is_site_set_type_changed 版位类型变更
       * is_site_sets_changed  版位变更
       * is_delivery_platform_type_changed 投放平台变更
       */
      const valid = [is_site_set_type_changed, is_site_sets_changed, is_delivery_platform_type_changed].some(v => v);

      if (valid) {
        delete form_assign_data.creative_config;

        const {
          campaign_config: {
            config: {
              delivery_form: {
                config: {
                  delivery_platform_type,
                },
              },
              site_form: {
                config: {
                  site_set_type,
                  site_sets,
                },
              },
            },
          },
          creative_config: {
            config: {
              content_form: {
                config: {
                  delivery_mode,
                  creative_template_id,
                },
              },
            },
          },
        } = config;

        const template_params = {
          filtering: {
            ...(site_set_type.value === 2 && { site_sets: site_sets.value }),
            delivery_platform_type: delivery_platform_type.value,
          },
        };
        // 获取创意规格选项
        creative_template_id.options = await controller.getCreativeTemplateList(template_params);
        creative_template_id.value = creative_template_id.options[0].value;
        creative_template_id.backup_value = creative_template_id.value;

        const is_custom = delivery_mode.value === '0';
        const params = {
          ...(site_set_type.value === 2 && { filtering: { site_sets: site_sets.value }}),
          baidu_params: {
            filtering: {
              delivery_platform_type: delivery_platform_type.value,
              delivery_mode: delivery_mode.value,
              ...(is_custom && { creative_template_id: creative_template_id.value }),
            },
          },
        };

        await this.renderDynamicComponent({ config, params, controller });
      }

      /**
       * 以下出价可见性变更时，同步更新创意出价，但不重新渲染动态创意
       * is_price_visible_changed 广告出价可见性变更
       * is_ocpc_bid_visible_changed 优化目标出价可见性变更
       * is_deep_ocpc_bid_visible_changed 深度优化目标出价可见性变更
       * is_roi_ratio_visible_changed 使用ROI优化可见性变更
       */
      const is_price_visible_changed = hasOwnProperty(raw_ref_form_model['campaign_config.budget_and_bid_form'], 'price') !== hasOwnProperty(raw_form_model['campaign_config.budget_and_bid_form'], 'price');
      const is_ocpc_bid_visible_changed = hasOwnProperty(raw_ref_form_model['campaign_config.budget_and_bid_form'], 'ocpc_bid') !== hasOwnProperty(raw_form_model['campaign_config.budget_and_bid_form'], 'ocpc_bid');
      const is_deep_ocpc_bid_visible_changed = hasOwnProperty(raw_ref_form_model['campaign_config.budget_and_bid_form'], 'deep_ocpc_bid') !== hasOwnProperty(raw_form_model['campaign_config.budget_and_bid_form'], 'deep_ocpc_bid');
      const is_roi_ratio_visible_changed = hasOwnProperty(raw_ref_form_model['campaign_config.budget_and_bid_form'], 'roi_ratio') !== hasOwnProperty(raw_form_model['campaign_config.budget_and_bid_form'], 'roi_ratio');

      const is_bid_changed = [is_price_visible_changed, is_ocpc_bid_visible_changed, is_deep_ocpc_bid_visible_changed, is_roi_ratio_visible_changed].some(v => v);
      if (is_bid_changed) {
        delete form_assign_data.creative_config;

        const {
          campaign_config: {
            config: {
              budget_and_bid_form: {
                config: {
                  price_strategy,
                },
              },
            },
          },
          creative_config: {
            config: {
              content_form: {
                config: {
                  delivery_mode,
                },
              },
              creative_price,
            },
          },
        } = config;
        creative_price.config = clone(creative_price_config);

        this.addEvent(config, controller);

        const is_max = price_strategy.value === '2';
        const is_custom = delivery_mode.value === '0';
        const { bid_source } = creative_price.config;

        (is_custom || is_max) && (bid_source.value = 2);
        bid_source.props.disabled = (is_custom || is_max);
        bid_source.on.change();
      }
    }
  }

  /**
   * 渲染创意动态组件
   * @param {Object} data 配置项
   * @param {Object} data.config 模块表单配置
   * @param {Object} data.params 查询参数
   * @param {Object} data.controller 控制器
   * @param {string[]} data.creative_config_keys 创意配置键
   */
  async renderDynamicComponent({ config, params, controller }) {
    const dynamic_component_keys = ['brand', 'subtitle', 'plugin_ids', 'prog_flag', 'video_text', 'idea_plugin_group'];
    const {
      campaign_config: {
        config: {
          delivery_form,
        },
      },
      creative_config: {
        config: {
          content_form,
          creative_components,
        },
      },
      material_config: {
        config: {
          material_form,
        },
      },
    } = config;

    const { names, list } = await controller.getDynamicComponent(params);
    // 重新初始化表单配置
    content_form.config = Object.assign(content_form.config, clone(content_form_config));
    creative_components.config = clone(creative_components_config);

    [content_form, creative_components].forEach(target => {
      Object.keys(target.config).forEach(key => {
        if (!names.includes(key) && dynamic_component_keys.includes(key)) {
          delete target.config[key];
        }
      });
    });

    const { delivery_platform_type } = delivery_form.config;
    const is_site = delivery_platform_type.value === '1';
    // 投放平台非【网站链接['1']】时，移除落地页跳转类型
    if (!is_site) {
      delete content_form.config.fusion__site_type;
    }

    this.addEvent(config, controller);

    const {
      fusion__site_type,
    } = content_form.config;

    const {
      additional_creative_information,
    } = creative_components.config;

    const {
      material,
    } = material_form.config;

    const mapTuple = [
      // 落地页跳转类型
      [
        () => isNotNullAndUnDef(fusion__site_type),
        () => {
          fusion__site_type.on.change();
        },
      ],
      // 附加创意信息
      [
        () => isNotNullAndUnDef(additional_creative_information),
        () => {
          const is_has_comment_num = names.includes('comment_num');
          const is_has_read_num = names.includes('read_num');
          const is_has_play_num = names.includes('play_num');

          if (is_has_comment_num || is_has_read_num || is_has_play_num) {
            additional_creative_information.options = [
              ...(is_has_comment_num ? [{ label: '评论数', value: 'comment_num' }] : []),
              ...(is_has_read_num ? [{ label: '阅读量', value: 'read_num' }] : []),
              ...(is_has_play_num ? [{ label: '播放量', value: 'play_num' }] : []),
            ];
          } else {
            delete creative_components.config.additional_creative_information;
          }
        },
      ],
      // 图片/组图素材限制
      [
        () => names.includes('image'),
        () => {
          const image = list.find(item => item.name === 'image');
          const width = image?.restriction?.image_restriction?.width;
          const height = image?.restriction?.image_restriction?.height;
          const is_has_restriction = width && height;
          const is_image_list = image?.array_property?.max_number > 1;
          material.materialRestriction = is_has_restriction ? [{ width, height }] : [];
          material.material_type = is_has_restriction ? (is_image_list ? 'element_story' : 'image') : null;
          if (is_has_restriction) {
            material.value.videos = [];
            material.value.tab = 'image';
          }
        },
      ],
      // 视频素材限制
      [
        () => names.includes('video'),
        () => {
          const video = list.find(item => item.name === 'video');
          const width = video?.restriction?.video_restriction?.min_width;
          const height = video?.restriction?.video_restriction?.min_height;
          const is_has_restriction = width && height;
          material.materialRestriction = is_has_restriction ? [{ width, height }] : [];
          material.material_type = is_has_restriction ? 'video' : null;
          if (is_has_restriction) {
            material.value.images = [];
            material.value.tab = 'video';
          }
        },
      ],
      /**
       * 素材
       * - 不存在video和image时，即为不限制素材规格，且图片素材支持切换 单图/组图
       */
      [
        () => isNotNullAndUnDef(material),
        () => {
          const is_limit_material = !names.includes('video') && !names.includes('image');
          is_limit_material && (material.value.tab = 'video');
          Object.assign(material, {
            ...(is_limit_material && {
              materialRestriction: [],
              material_type: null,
            }),
            isSupportSwitchImgType: is_limit_material,
          });
        },
      ],
    ];
    mapTuple.forEach(([condition, handler]) => (condition() && handler()));
  }

  /**
   * 转换差异化广告预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   */
  transformDifferentiatedCampaignPreviewPayload({ form_assign_data }) {
    const {
      campaign_config: {
        delivery_form: {
          download_type,
          open_url,
        },
        schedule_form: {
          time_period_type,
          schedule_time,
          time_period,
        },
        budget_and_bid_form: {
          fusion__optimize_goal,
          deep_convert_type,
          trans_type_attribute,
          use_roi,
          ocpc_bid,
          deep_ocpc_bid,
          roi_ratio,
        },
      },
    } = form_assign_data;

    return {
      /** 投放时间类型 */
      time_period_type,
      /** 投放时间 - 全天 */
      ...(time_period_type === 'TIME_PERIOD_ALL' && { time_period: new Array(TIME_PERIOD_LENGTH.HOUR).fill(1).join('') }),
      /** 投放时间 - 指定时间 */
      ...(time_period_type === 'TIME_PERIOD_DAY_SPECIFIC' && { time_period: transformSelectedTimeToTimeSeries(schedule_time.start, schedule_time.end) }),
      /** 投放时间 - 指定多个时间 */
      ...(time_period_type === 'TIME_PERIOD_HOUR_SPECIFIC' && { time_period: time_period.schedule_time_content }),
      /** 下载方式 */
      ...(download_type && { download_type }),
      /** 优先应用商店下载 */
      ...(open_url && { open_url }),
      /** 优化目标 */
      ...(fusion__optimize_goal && { convert_goal: fusion__optimize_goal }),
      /** 深度优化目标 */
      ...(deep_convert_type && { deep_convert_goal: deep_convert_type }),
      /** 付费优化类型 */
      ...(trans_type_attribute && { trans_type_attribute }),
      /** 使用ROI优化 */
      ...(use_roi && { use_roi }),
      /** 优化目标出价 */
      ...(ocpc_bid && { ocpc_bid: calculator.times(ocpc_bid, 100) }),
      /** 深度优化目标出价 */
      ...(deep_ocpc_bid && { deep_ocpc_bid: calculator.times(deep_ocpc_bid, 100) }),
      /** 深度ROI系数出价 */
      ...(roi_ratio && { roi_ratio }),
    };
  }

  /**
   * 转换差异化创意预览参数
   * @param {Object} data 数据
   * @param {Object} data.form_assign_data 提交参数
   * @returns {Object}
   */
  transformDifferentiatedCreativePreviewPayload({ form_assign_data }) {
    const {
      creative_config: {
        content_form: {
          delivery_mode,
          creative_template_id,
          images_num_per_creative,
          videos_num_per_creative,
          titles_num_per_creative,
          sites_num_per_creative,
          brand,
        } = {},
        creative_components: {
          subtitle,
          plugin_ids = {},
          additional_creative_information,
          prog_flag,
          video_text,
          idea_plugin_group,
        } = {},
        creative_price: {
          bid_source,
          price: creative_price_price,
          ocpc_bid: creative_price_ocpc_bid,
          deep_ocpc_bid: creative_price_deep_ocpc_bid,
          roi_ratio: creative_price_roi_ratio,
        } = {},
      },
    } = form_assign_data;

    const plugins = Object.entries(plugin_ids).map(([advertiser_id, list = []]) => {
      return {
        advertiser_id,
        ids: list.map(({ id }) => id),
      };
    }).filter(({ ids }) => ids.length);

    return {
      /** 投放模式 */
      delivery_mode,
      /** 分配规则 */
      ...(delivery_mode === '1' && { extra_dispatch_rules: {
        images_num_per_creative,
        videos_num_per_creative,
        titles_num_per_creative,
        sites_num_per_creative,
      }}),
      /** 创意形式 */
      ...(creative_template_id && { creative_template_id }),
      /** 品牌形象 */
      ...(brand && { brand: { name: brand.brand_name, url: brand.brand_url }}),
      /** 副标题 */
      ...(subtitle && { subtitle }),
      /** 创意磁贴 */
      ...(plugins.length && { plugins }),
      /** 附加创意信息 */
      ...(additional_creative_information && {
        /** 评论数 */
        ...(additional_creative_information.includes('comment_num') && { comment_num: '1' }),
        /** 阅读量 */
        ...(additional_creative_information.includes('read_num') && { read_num: '1' }),
        /** 播放量 */
        ...(additional_creative_information.includes('play_num') && { play_num: '1' }),
      }),
      /** 创意工具 */
      ...(prog_flag && { prog_flag }),
      /** 前卡模块文案 */
      ...(video_text && { video_text: { first_text: video_text.first_text, second_text: video_text.second_text }}),
      /** 微信小游戏组件 */
      ...(idea_plugin_group && { idea_plugin_group: { wechat_miniprogram_name: idea_plugin_group.wechat_miniprogram_name, wechat_miniprogram_id: idea_plugin_group.wechat_miniprogram_id }}),
      /** 使用单元出价 */
      ...(bid_source && { bid_source }),
      /** 单元出价参数 */
      ...(bid_source === 1 && {
        adgroup_bid_params: {
          ...(creative_price_price && { price: calculator.times(creative_price_price, 100) }),
          ...(creative_price_ocpc_bid && { ocpc_bid: calculator.times(creative_price_ocpc_bid, 100) }),
          ...(creative_price_deep_ocpc_bid && { deep_ocpc_bid: calculator.times(creative_price_deep_ocpc_bid, 100) }),
          ...(creative_price_roi_ratio && { roi_ratio: creative_price_roi_ratio }),
        },
      }),
    };
  }

  /**
   * 获取创建定向包差异化接口参数
   * @param {Object} target_data 定向数据
   * @returns {Object}
   */
  getDifferentiatedCreateTargetParams(target_data) {
    const {
      age: {
        age_selection,
        age,
      },
      life_stage,
      education,
      net,
    } = target_data;

    const target_params = {
      [`${CHANNEL_INTERFACE_TYPE.BAIDU}_params`]: {
        // 年龄
        ...(age_selection === OPTIONS_TYPE.CUSTOM && { age }),
        // 人生阶段
        ...(!life_stage.includes(OPTIONS_TYPE.UNLIMITED) && { life_stage }),
        // 学历
        ...(!education.includes(OPTIONS_TYPE.UNLIMITED) && { education }),
        // 网络
        ...(net !== OPTIONS_TYPE.UNLIMITED && { net }),
      },
    };

    return target_params;
  }

  /**
   * 获取定向包差异化详情表单数据
   * @param {Object} target_params 定向详情数据
   * @returns {Object}
   */
  getDifferentiatedTargetDetailFormData(target_params) {
    const {
      [`${CHANNEL_INTERFACE_TYPE.BAIDU}_params`]: {
        age,
        life_stage,
        education,
        net,
      } = {},
    } = target_params;

    const form_data = {
      // 年龄
      ...(age && {
        age: {
          age_selection: OPTIONS_TYPE.CUSTOM,
          age,
        },
      }),
      // 人生阶段
      ...(life_stage && { life_stage }),
      // 学历
      ...(education && { education }),
      // 网络
      ...(net && { net }),
    };

    return form_data;
  }

  /**
   * 获取定向数据转预览数据关联表
   * @returns {Object}
   */
  getTargetPreviewAssociatedMap() {
    return {
      age_selection: {
        associated_keys: ['age'],
      },
    };
  }

  /**
   * 获取素材属性
   * @param {Object} material_config 素材表单配置
   * @returns {Object}
   */
  getMaterialProps(material_config) {
    const { materialRestriction, material_type, isSupportSwitchImgType } = material_config?.config?.material_form?.config?.material;
    return {
      materialRestriction,
      ...(material_type && { type: material_type }),
      isSupportSwitchImgType,
    };
  }

  /**
   * 设置源数据表单
   * @param {Object} source 源数据
   * @param {Object} target 目标数据
   * @returns {void}
   */
  setSourceFormFieldsData(source, target) {
    const {
      material_config: {
        config: {
          material_form: {
            config: {
              material,
            },
          },
        },
      },
    } = source;

    const {
      material_config: {
        config: {
          material_form: {
            config: {
              material: target_material,
            },
          },
        },
      },
    } = target;

    // 保持数据引用
    material.value.images.splice(0);
    material.value.images.push(...target_material.value.images);
    material.value.videos.splice(0);
    material.value.videos.push(...target_material.value.videos);
    material.value.tab = target_material.value.tab;

    Object.assign(material, {
      materialRestriction: target_material.materialRestriction,
      material_type: target_material.material_type,
      isSupportSwitchImgType: target_material.isSupportSwitchImgType,
    });
  }

  /**
   * 获取差异化模板配置表
   * @returns {Object}
   */
  getDifferentiatedTemplateMap() {
    return {
      campaign_config: {
        delivery_form: ['channel_package_id', 'download_type', 'open_url'],
      },
      creative_config: {
        content_form: ['delivery_mode', 'videos_num_per_creative', 'images_num_per_creative', 'titles_num_per_creative', 'sites_num_per_creative', 'creative_template_id', 'brand', 'fusion__site_type'],
        creative_components: ['subtitle', 'additional_creative_information', 'prog_flag', 'video_text', 'idea_plugin_group'],
      },
    };
  }

  /**
   * 是否重新渲染动态创意
   * @param {Object} old_campaign_config 旧广告配置
   * @param {Object} new_campaign_config 新广告配置
   * @returns {Boolean}
   */
  isReRenderCreative(old_campaign_config, new_campaign_config) {
    const {
      delivery_form: {
        config: {
          delivery_platform_type: old_delivery_platform_type,
        },
      },
      site_form: {
        config: {
          site_set_type: old_site_set_type,
          site_sets: old_site_sets,
        },
      },
    } = old_campaign_config.config;

    const {
      delivery_form: {
        config: {
          delivery_platform_type: new_delivery_platform_type,
        },
      },
      site_form: {
        config: {
          site_set_type: new_site_set_type,
          site_sets: new_site_sets,
        },
      },
    } = new_campaign_config.config;

    const is_delivery_platform_type_changed = JSON.stringify(old_delivery_platform_type.value) !== JSON.stringify(new_delivery_platform_type.value);
    const is_site_set_type_changed = JSON.stringify(old_site_set_type.value) !== JSON.stringify(new_site_set_type.value);
    const is_site_sets_changed = JSON.stringify(old_site_sets.value) !== JSON.stringify(new_site_sets.value);

    /**
     * 只要以下条件任意一个满足，则重新请求获取创意组件
     * is_site_set_type_changed 版位类型变更
     * is_site_sets_changed  版位变更
     * is_delivery_platform_type_changed 投放平台变更
     */
    const valid = [is_site_set_type_changed, is_site_sets_changed, is_delivery_platform_type_changed].some(v => v);

    return valid;
  }

  /**
   * 是否显示预览按钮
   * @param {Object} form_assign_data 分配数据
   * @param {Object} form_fields 源数据
   * @param {Object} payload 配置参数
   * @returns {boolean}
   */
  isShowPreviewBtn(form_assign_data, form_fields, payload) {
    const { is_add_creative } = payload;
    const material = form_assign_data[MATERIAL_MODULE_KEY];
    const is_has_material = material?.images?.length > 0 || material?.videos?.length > 0;
    const {
      campaign_config: {
        config: {
          delivery_form: {
            config: {
              delivery_platform_type,
            },
          },
        },
      },
    } = form_fields;

    /**
     * 创建流程为 【添加创意】 流程时，以下模块非必填
     * - 广告
     * - 定向
     *
     * 投放平台为 非【网站链接['1']】 时，以下模块非必填
     * - 落地页
     */
    const is_link = delivery_platform_type.value === '1';
    if (is_add_creative || !is_link) {
      const basic_keys = [
        ...(is_add_creative ? [] : [CAMPAIGN_MODULE_KEY]),
        CREATIVE_MODULE_KEY,
      ];
      const assign_keys = [
        ...(is_add_creative ? [] : [TARGETING_MODULE_KEY]),
        TITLE_MODULE_KEY,
        ...(!is_link ? [] : [SITE_MODULE_KEY]),
      ];
      return basic_keys.every(key => !!form_assign_data[key]) && assign_keys.every(key => form_assign_data[key]?.length > 0) && is_has_material;
    } else {
      return super.isShowPreviewBtn(form_assign_data, form_fields);
    }
  }
}
